module.exports = __webpack_public_path__ + "static/img/ctyoushiright.02f37cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ctimaging/ctyoushiright.png
// module id = Flan
// module chunks = 5